module.exports = __webpack_public_path__ + "public/images/icon-calendare.27a5c7d7d692275ad849d164ea5063d8.svg";